export default __webpack_public_path__ + "static/media/2728 cutlery side.2b47e2b1.png";